const getVODImage = (imageId) => {
    // if(!imageId) return (...)
    return `https://ott.tvanywhereafrica.com:28182/api/client/v1/global/images/${imageId}?accessKey=WkVjNWNscFhORDBLCg==`
}

export default getVODImage